import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: var(--luft-primary);
  z-index: 2;
  color: var(--white);
  align-items: center;
  width: 100%;
  overflow: hidden;
  bottom: 0;
  position: fixed;
`;

export const BottomBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

`;
